import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_1khrj7y7: FaireBrandEntity = {
  token: "b_1khrj7y7",
  type: "brand",
  name: "Brightland",
  avatarUrl:
    "https://cdn.faire.com/fastly/61c4e62d3236171ccb0efd9e70b62e9742bb682ecec08d102662b63d6bd7821f.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/494858339e9072bf4f6c626f83b82d5b0bdd264c6dbdce0191e965d01926c135.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/61c4e62d3236171ccb0efd9e70b62e9742bb682ecec08d102662b63d6bd7821f.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/494858339e9072bf4f6c626f83b82d5b0bdd264c6dbdce0191e965d01926c135.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 50,
  isTopShop: true,
  isInsider: true,
  description:
    "Brightland was born to elevate simple, analog moments in the kitchen. Our consciously crafted products support small U.S. family farms and makers. Brightland extra virgin olive oils and vinegars are lovingly made on small family farms in California and contain nothing more than fruit, love and sunshine. Our mission has always been to pursue living in a golden state by celebrating everyday elegance, endless curiosity, and being fully engaged in the present. \n\nWe have collaborated with exciting brands and partners including sweetgreen, Oishii, The Slow Factory Foundation, The Cartorialist and Food52, and we have been featured by The New York Times, The Wall Street Journal and Food & Wine. Find us at Brightland.co and on IG @wearebrightland. ",
  meta: {
    source: "api",
    importedAt: "2026-07-09T05:19:22.699Z",
    importedBy: "entity-db-cli",
  },
};
